import { UI, COMMON } from "../types/actions";

export const resetField = (key, value, successHandler = null) => {
	successHandler && successHandler(value);
	return {
		type: COMMON.RESET_FIELD,
		key,
		value
	};
};

export const togglePreloader = (value) => {
	return {
		type: UI.TOGGLE_PRELOADER,
		payload: value
	};
};

export const toggleAtBottom = (value) => {
	return {
		type: UI.TOGGLE_AT_BOTTOM,
		payload: value
	};
};
